import React, {FunctionComponent} from 'react';
import {useTranslation} from "react-i18next";
import Dialog from "@mui/material/Dialog";
import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {MetadataData} from "../../../api/GovernanceToolApi";

export const DeleteMetadataDialog: FunctionComponent<DeleteMetadataProps> = props => {
    const {t} = useTranslation();
    const {metadata, onCancelClick, onOkClick} = props;

    return <Dialog maxWidth="sm"
                   aria-labelledby="confirmation-dialog-title"
                   open={true}
                   onClose={() => props.onCancelClick()}>
        <DialogTitle id="confirmation-dialog-title">{t("Delete metadata")}</DialogTitle>
        <DialogContent dividers>
            {t("deleteMetadataConfirmMessage")}
            <br/>
            <div style={{color: '#707070', textAlign: 'center'}}>{metadata.value}</div>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => onOkClick()} color="primary">
                {t("Ok")}
            </Button>
            <Button autoFocus onClick={() => onCancelClick()} color="primary">
                {t("Cancel")}
            </Button>
        </DialogActions>
    </Dialog>;
}

export interface DeleteMetadataProps {
    metadata: MetadataData;

    onCancelClick: () => void;
    onOkClick: () => void;
}
